/**
 * @description 此文件为公共常量文件，编辑删除请多注意添加注释并悉知其他地方是否使用，
 * @author yinshipeng
 */

export default {
    COURSE_TYPE: {
        H: '首页',
        a: '入驻流程',
        b: '档期提报',
        c: '发货售后',
        d: '对账结算',
        e: '视频教程',
        g: '平台玩法',
        f: '经典案例',
        h: '常销操作手册'
    }
};
